/**
 * @generated SignedSource<<03a4bafbb96d2fb70c2daff3ab62a295>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type Permission = "ADD" | "DEPLOY_POLICIES" | "EDIT" | "EDIT_ACL" | "LOGIN" | "REMOVE" | "VIEW" | "VIEW_ACL" | "VIEW_RESOURCES" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type RepositoryPicker_repositoryConfigs$data = {
  readonly repositoryConfigs: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly name: string;
        readonly roleAssignmentTarget: any;
        readonly userPermissions: ReadonlyArray<Permission>;
        readonly uuid: any;
      };
    }> | null | undefined;
  };
  readonly " $fragmentType": "RepositoryPicker_repositoryConfigs";
};
export type RepositoryPicker_repositoryConfigs$key = {
  readonly " $data"?: RepositoryPicker_repositoryConfigs$data;
  readonly " $fragmentSpreads": FragmentRefs<"RepositoryPicker_repositoryConfigs">;
};

import RepositoryPickerRefetchQuery_graphql from './RepositoryPickerRefetchQuery.graphql';

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "filterElement"
    },
    {
      "defaultValue": 1000,
      "kind": "LocalArgument",
      "name": "first"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "refetch": {
      "connection": null,
      "fragmentPathInResult": [],
      "operation": RepositoryPickerRefetchQuery_graphql
    }
  },
  "name": "RepositoryPicker_repositoryConfigs",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "filterElement",
          "variableName": "filterElement"
        },
        {
          "kind": "Variable",
          "name": "first",
          "variableName": "first"
        }
      ],
      "concreteType": "RepositoryConfigConnection",
      "kind": "LinkedField",
      "name": "repositoryConfigs",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "RepositoryConfigEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "RepositoryConfig",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "name",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "uuid",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "roleAssignmentTarget",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "userPermissions",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Query",
  "abstractKey": null
};

(node as any).hash = "7779da73921215f267eee5aec23efb65";

export default node;
